export default "__VITE_ASSET__BOO5L$EB__"